import React from "react";
import { Box, Text, useColorMode } from "@chakra-ui/react";

const PlaceholderTile = ({ message = "No data yet — log trades to see this metric." }) => {
  const { colorMode } = useColorMode();
  const bg = colorMode === "light" ? "gray.50" : "gray.600";
  const color = colorMode === "light" ? "gray.500" : "gray.300";
  return (
    <Box bg={bg} rounded="md" p={4} textAlign="center">
      <Text fontSize="sm" color={color}>{message}</Text>
    </Box>
  );
};

export default PlaceholderTile;
